import { Component, OnInit } from '@angular/core';
import { MaterialModule } from '../../material.module';
import { MatTableDataSource } from '@angular/material/table';
import { JkBaseComponent } from '../jkbase/jkbase.component';

@Component({
  selector: 'app-jktable',
  standalone: true,
  imports: [    MaterialModule,
  ],
  templateUrl: './jktable.component.html',
  styleUrl: './jktable.component.css'
})
export class JktableComponent extends JkBaseComponent implements OnInit { // jkQueryComponent
  override comType: string = 'jktable';
  dataSource = new MatTableDataSource<any>(); //any[] = [];
  constructor() {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();
  }

}
